<template>
  <div>
        <div style="position: relative;">
            <img style="position: absolute;right: 10px;" v-if="bulletinList.State==5" src="../../assets/status5.png" alt="" />
            <img style="position: absolute;right: 10px;" v-else-if="bulletinList.State==4" src="../../assets/status4.png" alt="">
        </div>
        <div class="layui-card" style="min-height:800px">
            <div class="layui-card-body">
                <div class="layui-form  layui-form-pane" lay-filter="example">
                    <p class="titleProject">项目基本信息</p>
                    <table class="layui-table" style="width: 100%;">
                        <colgroup>
                            <col width="150">
                            <col width="200">
                            <col>
                        </colgroup>
                        <tbody>
                            <tr>
                                <td class="JBtitle">项目编号:</td>
                                <td class="JBvalue" id="PrjNo">
                                    {{bulletinList.PrjNo}}
                                    </td>
                                <td class="JBtitle">项目名称:</td>
                                <td class="JBvalue" id="PrjName">
                                    {{bulletinList.PrjName}}
                                    </td>
                            </tr>
                            <tr>
                                <td class="JBtitle">采购单位:</td>
                                <td class="JBvalue" id="YzCompanyName">
                                    {{bulletinList.YzCompanyName}}
                                    </td>
                                <td class="JBtitle">品目分类:</td>
                                <td class="JBvalue" id="CallingName">
                                    {{bulletinList.CallingName}}
                                    </td>
                            </tr>
                            <tr>
                                <td class="JBtitle">经办人:</td>
                                <td class="JBvalue" id="YzCompanyLinkMan">
                                    {{bulletinList.YzCompanyLinkMan}}
                                    </td>
                                <td class="JBtitle">联系电话:</td>
                                <td class="JBvalue" id="YzCompanyLinkPhone">
                                    {{bulletinList.YzCompanyLinkPhone}}
                                    </td>
                            </tr>
                            <tr v-if="bulletinList.AgentCompanyLinkMan!=''">
                                <td class="JBtitle">代理联系人:</td>
                                <td class="JBvalue" id="YzCompanyLinkMan">
                                    {{bulletinList.AgentCompanyLinkMan}}
                                    </td>
                                <td class="JBtitle">代理联系人电话:</td>
                                <td class="JBvalue" id="YzCompanyLinkPhone">
                                    {{bulletinList.AgentCompanyLinkMb}}/{{bulletinList.AgentCompanyLinkPhone}}
                                    </td>
                            </tr>
                            <tr>
                                <td class="JBtitle">{{bulletinList.BookSellMoney == 100?'报名系统使用费(元)':'标书售价(元)'}}:</td>
                                <td class="JBvalue" id="BookSellMoney">
                                    {{bulletinList.BookSellMoney}}
                                    </td>
                                <td class="JBtitle">保证金金额(元):</td>
                                <td class="JBvalue" id="BidDeposit">
                                    {{bulletinList.BidDeposit}}
                                    </td>
                            </tr>
                            <tr>
                                <td class="JBtitle">报名时间:</td>
                                <td class="JBvalue" id="SignTimeStr">
                                    {{bulletinList.SignUpDate + " - " + bulletinList.SignUpEndDate}}
                                    </td>
                                <td v-if="biddingType!='1'" class="JBtitle">报价时间:</td>
                                <td v-else class="JBtitle">自由报价时间:</td>
                                <td class="JBvalue" id="KbTimeStr">
                                    {{bulletinList.ZTBTypeId=="0208"?bulletinList.KbDate + " - " + bulletinList.KbEndDate:bulletinList.SignUpDate + " - " + bulletinList.KbEndDate}}
                                </td>
                            </tr>
                            <tr v-if="biddingType=='1'">
                                <td class="JBtitle">限时报价开始时间:</td>
                                <td class="JBvalue" id="SignTimeStr">
                                    {{bulletinList.ZTBTypeId=="0208"?bulletinList.KbEndDate:bulletinList.KbEndDate}}
                                    </td>
                                <td class="JBtitle">限时报价期:</td>
                                <td class="JBvalue" id="KbTimeStr">120s</td>
                            </tr>
                            <tr class="EnterCustomerClassDiv" style="display:none;">
                                <td class="JBtitle">是否启用合格供应商库:</td>
                                <td class="JBvalue" id="isEnterCustomerTxt" colspan=3>
                                    {{bulletinList.isEnterCustomer == "1" ? "是" : "否"}}
                                    </td>
                            </tr>
                            <tr>
                                <td class="JBtitle">采购内容:</td>
                                <td class="JBvalue" id="Remark" colspan=3>
                                    {{bulletinList.PrjContent}}
                                    </td>
                            </tr>
                            <tr>
                                <td class="JBtitle">商务要求:</td>
                                <td class="JBvalue" id="Remark" colspan=3>
                                    {{bulletinList.Remark}}
                                    </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="layui-from">
                    <p class="titleProject">
                        采购物品清单
                    </p>
                    <span v-for="item in bulletinList.SectProductList" :key="item.key">
                    <!-- <a-table style="width: 100%" bordered :columns="columns" :data-source="bulletinList.ProductList" :rowKey="record=>record.Name" :pagination="false">
                        <span slot="UnitPrice" slot-scope="text, record">
                            {{text + (record.UnitPriceUnit== "0" ? "元" : "%")}}
                        </span>
                        <span slot="TotalBudget" slot-scope="text, record">
                            {{text + (record.UnitPriceUnit== "0" ? "元" : "%")}}
                        </span>
                    </a-table> -->
                    <p  class="titleProject" style="font-weight: 500;">标段名称：{{item.SectName}}</p>
                    <a-table style="width: 100%;margin-bottom:25px" bordered :columns="columns" :data-source="item.Data" :rowKey="record=>record.Name" :pagination="false">
                        <span slot="UnitPrice" slot-scope="text, record">
                            {{text + (record.UnitPriceUnit== "0" ? "元" : "%")}}
                        </span>
                        <span slot="TotalBudget" slot-scope="text, record">
                            {{text + (record.UnitPriceUnit== "0" ? "元" : "%")}}
                        </span>
                    </a-table>
                    </span>
                </div>
                <div class="layui-from">
                    <p class="titleProject" v-if="bulletinList.BulletinContent.length>0">
                        变更公告
                    </p>
                    <span v-if="bulletinList.BulletinContent">
                        <span v-for="(item,index) of bulletinList.BulletinContent" :key="index">
                            <div><p style="font-weight: bold;display: inline-block;margin-right: 15px;">{{ item.BulletinTitle }}</p> 发布时间：{{ item.PublishDate }}</div>
                            <div v-html="item.BulletinContent"></div>
                        </span>
                    </span>
                </div>
                <div class="layui-from">
                    <div class="titleProject" style="color: red;">
                        1.登录网上投标系统进入 [网上报名] - [项目报名]，先进行报名。<br>
                        2.支付报名系统使用费。<br>
                        3.支付保证金。<br>
                        4.1电子询价：进入[电子询价] - [上传加盖公章后的报价单] - [待报价]，进行报价；<br>
                        4.2电子竞价：进入[电子竞价] - [正在竞价]，等待竞价时间开始，进行竞价；<br>
                        4.3电子比选：进入[电子比选] - [待报价]，先上传响应文件，再进行报价；<br>
                        4.4 各种报价方式具体查看：<router-link style="font-weight: 600;" target="_blank" to="/detail?articleId=285">https://ygcg.nbcqjy.org/detail?articleId=285</router-link><br>
                    </div>
                </div>
                <div class="layui-from" style="text-align:center">
                    <button v-if="wjs" id="wjs" class="layui-btn layui-btn-normal" @click="baojia()">我要报价</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
const columns = [
  {
    title: "序号",
    dataIndex:'index',
    customRender: (text, record, index) => `${index + 1}`,
    width: 70,
  },
  
  {
    title: '货物或服务名称',
    dataIndex: 'Name',
    width: 180,
  },
  {
    title: '品牌',
    dataIndex: 'Brand',
    width: 100,
  },
  {
    title: '规格型号',
    dataIndex: 'Model',
    width: 150,
  },
  {
    title: '预算单价',
    dataIndex: 'UnitPrice',
    slots: { title: 'UnitPrice' },
    scopedSlots: { customRender: 'UnitPrice' },
    width: 120,
  },
  {
    title: '数量',
    dataIndex: 'Quantity',
    width: 100,
  },
  {
    title: '单位',
    dataIndex: 'Unit',
    width: 70,
  },
  {
    title: '预算总价',
    dataIndex: 'TotalBudget',
    slots: { title: 'TotalBudget' },
    scopedSlots: { customRender: 'TotalBudget' },
    width: 120,
  },
  {
    title: '配置及技术指标',
    dataIndex: 'Remarks',
    width: 200,
  },
];
export default {
  name: "bulletin-text",
  props: {
    TextList: {
      type: Object,
      default() {
        return {
          prjId: '',
        };
      },
    },
  },
  data() {
    return {
        columns,
        bulletinList:{},
        wjs:true,
        biddingType:this.$route.query.biddingType
    };
  },
  created() {
      this.$http.get('https://ygcg.nbcqjy.org:8075/api/Notoken/GetOnlineInquire?PrjId='+this.TextList.prjId).then((res) => {
            this.bulletinList = res.data.Body.Data;
            var date = new Date();
            var myDate = new Date(date).getTime();
            var jsDate = new Date(res.data.Body.Data.KbEndDate).getTime();
            if (jsDate < myDate||res.State=='1'||res.State=='4') {
                this.wjs = false;
            }
      })
  },
  methods: {
      baojia(){
        window.open('https://ygcg.nbcqjy.org:8071/login.html?PrjId=' + this.TextList.prjId, '_blank')
      }
  },
};
</script>
<style lang="less">
        body {
            padding-top: 0px !important;
        }

        .dtree-theme-item-this {
            background-color: transparent !important;
        }

        .JBtitle {
            background-color: #FBFBFB;
            width: 17%;
            text-align: center;
        }

        .JBvalue {
            width: 33%;
        }

        /*       .layui-input,
        .layui-textarea {
            border-width: 0px;
        }*/

        textarea {
            resize: none;
        }

        .layui-form-label {
            width: 16% !important;
        }

        .layui-input-inline {
            width: 30% !important;
        }

        .layui-input-block {
            margin-left: 230px !important;
        }

        #Remark {
            width: 80% !important;
            line-height: 36px;
            min-height: 38px;
            border: 1px solid #e6e6e6;
            box-sizing: border-box;
        }

        .layui-table-cell {
            height: auto;
            overflow: visible;
            text-overflow: inherit;
            white-space: normal;
        }
        .titleProject {
            color: #222;
            margin: 0;
            font-size: 16px;
            padding: 16px 24px 6px 24px;
            font-weight: bold;
        }

        #ProjectEdit .layui-form-label {
            width: 32%;
        }

        #ProjectEdit .layui-form-item .layui-input-inline {
            width: 40%;
        }


        /* 修改layui */
        .layui-form-item .layui-inline{
            margin-bottom: 0px;
        }
        .layui-form-item .layui-form-checkbox[lay-skin=primary]{
            margin-top: 0;
        }
        td{
            padding: 9px 15px!important;
        }
        .layui-btn {
            display: inline-block;
            height: 38px;
            line-height: 38px;
            padding: 0 18px;
            background-color: #1E9FFF;
            color: #fff;
            white-space: nowrap;
            text-align: center;
            font-size: 14px;
            border: none;
            border-radius: 2px;
            cursor: pointer;
        }
        table td, table th {
            border-bottom: 1px solid #e6e6e6!important;
            border-right: 1px solid #e6e6e6!important;
        }
        table {
            border-top: 1px solid #e6e6e6!important;
            border-left: 1px solid #e6e6e6!important;
        }
</style>